export class PolicyDetailsModel {
  insuranceCompanyName: string;
  policyNumber: number;
  startDate: Date;
  expiryDate: Date;
  premiumAmount: number;
  orderId: number;
  status: string;
  requestStatus?: string;

  constructor(
    insuranceCompanyName?: string,
    policyNumber?: number,
    premiumAmount?: number,
    startDate?: Date,
    expiryDate?: Date,
    orderId?: number,
    status?: string,
    requestStatus?: string
  ) {
    (this.insuranceCompanyName = insuranceCompanyName),
      (this.policyNumber = policyNumber),
      (this.startDate = startDate),
      (this.expiryDate = expiryDate),
      (this.premiumAmount = premiumAmount),
      (this.orderId = orderId);
    this.status = status;
    this.requestStatus = requestStatus;
  }
}

export enum RateCardType {
  RATE_CARD = "rate_card",
  ADD_ONS = "add_ons",
}

export enum RCValueType {
  CALCULATIVE = "Calculative",
  TEXT = "Text",
}

export enum PlanType {
  TPL = "tpl",
  COMPREHENSIVE = "comprehensive",
  TPLANDCOMPREHENSIVE = "tplAndComprehensive",
}

export enum PlanStatus {
  NEW_QUOTE = "New Quote",
  DELIVERED = "Delivered",
  PAY_NOW = "Pay Now",
  UNSUBMITTED_QUOTE = "Unsubmitted Quote",
  WAITING_FOR_APPROVAL = "Waiting For Approval",
  REJECTED = "Rejected",
  QUOTE_EXPIRED = "Quote Expired",
  PROCESSED = "Policy Printed",
}

export enum QuoteStatus {
  QUOTE_SUBMITTED = "QUOTE_SUBMITTED",
  CUSTOMER_REJECTED = "CUSTOMER_REJECTED",
  ADMIN_APPROVED = "ADMIN_APPROVED",
  INSURER_DENIED = "INSURER_DENIED",
  QUOTE_UPDATED = "QUOTE_UPDATED",

  NEW_QUOTE = "New Quote",
  APPROVED = "Approved Request",
  REJECT = "Reject",
  CONDITIONALLY_APPROVE = "Conditionally Approve",
  REJECTED = "Rejected",
  PAYMENT_RECEIVED = "PAYMENT_RECEIVED",
  WAITING_FOR_APPROVAL = "Waiting For Approval",
  NOT_SUBMITTED = "Not Submitted",
  PROCESSED = "PROCESSED",
  PAYMENT_DONE = "PAYMENT_DONE",
  DELIVERED = "DELIVERED",
  DISPATCHED = "DISPATCHED",
}

export enum Steps {
  QUOTES = 1,
  USER_INFO = 2,
  CONFIRMATION = 3,
  SUCCESS = 6,
}
